import { Action } from 'redux';
export const GET_SYSTEM_ALERT_CONTENTS = 'driver-home-page/GET_SYSTEM_ALERT_CONTENTS';
export const SET_SYSTEM_ALERT_CONTENTS = 'driver-home-page/SET_SYSTEM_ALERT_CONTENTS';
export const PERSIST_SYSTEM_ALERT = 'driver-home-page/PERSIST_SYSTEM_ALERT';
export const UPDATE_SUPER_ADMIN_ALERT = 'driver-home-page/UPDATE_SUPER_ADMIN_ALERT';
/**
 * Get home page contents
 */
export interface GetSystemAlertContentsAction extends Action<typeof SET_SYSTEM_ALERT_CONTENTS> {
  payload: any;
}

export const getSystemAlertContents = () => ({
  type: GET_SYSTEM_ALERT_CONTENTS,
});

export const setSystemAlertContents = (data: any): GetSystemAlertContentsAction => ({
  type: SET_SYSTEM_ALERT_CONTENTS,
  payload: data,
});

export const persistSystemAlert = (data: any) => ({
  type: PERSIST_SYSTEM_ALERT,
  payload: data,
});
export const updateDriverSystemAlert = (data: any) => {
  return {
    type: UPDATE_SUPER_ADMIN_ALERT,
    payload: data,
  };
};
